<div class="shop-add component-container component-page-container action-button-wrapper">
    <div class="sh-page-wrapper bottom-action-mg" fxLayout="row" fxLayout.md="column" fxLayoutGap="1%">
        <div fxFlex="45%">
            <custom-panel header="Opis placówki" [areButtons]="false" class="flex flex-grow">
                <div fxLayout="column" panel-body>
                    <div class="sh-page-info-desc-wrapper">
                        <!-- <p class="mv-s pl-s mat-title upper text-primary" align="center">{{ store.Name || '-' }}</p> -->

                        <div class="sh-page-desc mv-xxs" fxLayout="row" fxLayoutGap="2%">
                            <p class="upper" fxFlex="50%">Nazwa placówki</p>
                            <p fxFlex="50%" class="text-color-primary">{{ store.Name || '-' }}</p>
                        </div>
                        <div class="sh-page-desc mv-xxs" fxLayout="row" fxLayoutGap="2%">
                            <p class="upper" fxFlex="50%">Numer placówki</p>
                            <p fxFlex="50%" class="text-color-primary">{{ store.Number || '-' }}</p>
                        </div>
                        <div class="sh-page-desc mv-xxs" fxLayout="row" fxLayoutGap="2%">
                            <p class="upper" fxFlex="50%">ID placówki</p>
                            <p fxFlex="50%" class="text-color-primary">{{ store.Id || '-' }}</p>
                        </div>
                        <div class="sh-page-desc mv-xxs" fxLayout="row" fxLayoutGap="2%">
                            <p class="upper" fxFlex="50%">województwo</p>
                            <p fxFlex="50%" class="text-color-primary">{{ store.Region0 || '-' }}</p>
                        </div>
                        <div class="sh-page-desc mv-xxs" fxLayout="row" fxLayoutGap="2%">
                            <p class="upper" fxFlex="50%">region</p>
                            <p fxFlex="50%" class="text-color-primary">{{ store.Region1 || '-' }}</p>
                        </div>
                        <div class="sh-page-desc mv-xxs" fxLayout="row" fxLayoutGap="2%">
                            <p class="upper" fxFlex="50%">miasto</p>
                            <p fxFlex="50%" class="text-color-primary">{{ store.City || '-' }}</p>
                        </div>
                        <div class="sh-page-desc mv-xxs" fxLayout="row" fxLayoutGap="2%">
                            <p class="upper" fxFlex="50%">kod pocztowy</p>
                            <p fxFlex="50%" class="text-color-primary">{{ store.ZipCode || '-' }}</p>
                        </div>
                        <div class="sh-page-desc mv-xxs" fxLayout="row" fxLayoutGap="2%">
                            <p class="upper" fxFlex="50%">Adres</p>
                            <p fxFlex="50%" class="text-color-primary">{{ store.Street || '-' }} {{ store.StreetNumber }}</p>
                        </div>
                        <div class="sh-page-desc mv-xxs" fxLayout="row" fxLayoutGap="2%">
                            <p class="upper" fxFlex="50%">Powierzchnia placówki</p>
                            <p fxFlex="50%" class="text-color-primary">{{ store.Surface || '-' }}</p>
                        </div>
                        <div class="sh-page-desc mv-xxs" fxLayout="row" fxLayoutGap="2%">
                            <p class="upper" fxFlex="50%">Rodzaj placówki</p>
                            <p fxFlex="50%" class="text-color-primary">{{ store.Rodzaj || '-' }}</p>
                        </div>
                        <div class="sh-page-desc mv-xxs" fxLayout="row" fxLayoutGap="2%">
                            <p class="upper" fxFlex="50%">liczba kas</p>
                            <p fxFlex="50%" class="text-color-primary">{{ store.CheckboxNb || '-' }}</p>
                        </div>
                        <div class="sh-page-desc mv-xxs" fxLayout="row" fxLayoutGap="2%">
                            <p class="upper" fxFlex="50%">rodzaj asortymentu</p>
                            <p fxFlex="50%" class="text-color-primary">{{ store.StockType || '-' }}</p>
                        </div>
                        <div class="sh-page-desc mv-xxs" fxLayout="row" fxLayoutGap="2%">
                            <p class="upper" fxFlex="50%">klaster</p>
                            <p fxFlex="50%" class="text-color-primary">{{ getCluster(store.ClusterId)?.name || '-' }}</p>
                        </div>
                        <div class="sh-page-desc mv-xxs" fxLayout="row" fxLayoutGap="2%">
                            <p class="upper" fxFlex="50%">czy są lodówki z piwem</p>
                            <p fxFlex="50%" class="text-color-primary">{{ (store.FridgeBeer === 'true' ? 'tak' : 'nie') || '-' }}</p>
                        </div>
                        <div class="sh-page-desc mv-xxs" fxLayout="row" fxLayoutGap="2%">
                            <p class="upper" fxFlex="50%">czy są lodówki z lodami</p>
                            <p fxFlex="50%" class="text-color-primary">{{ (store.FridgeIceCream === 'true' ? 'tak' : 'nie') || '-'}}</p>
                        </div>
                    </div>
                </div>
            </custom-panel>
        </div>
        <div  fxFlex="53%">
            <custom-panel header="Lokalizacja placówki" [areButtons]="false" class="flex flex-grow">
                <div class="sh-page-info-map" fxLayout="column" panel-body>
                    <div class="sh-page-info-map-wrapper">
                        <div class="leaf-map">
                            <leaflet-maps
                                [options]="storeLoc"
                                [shopsAddress]="competitorStoresAdd"
                            >
                            </leaflet-maps>
                        </div>
                        <div class="sh-page-competitors">
                            <competitors-table [columnsData]="dataTableInfo" [compStores]="competitorStores" ></competitors-table>
                        </div>
                    </div>
                </div>
            </custom-panel>
        </div>
    </div>
</div>

<div class="action-buttons">
    <div class="action-buttons-inner pv-xxxs" fxLayout="row" fxLayoutGap="1%" fxLayoutAlign="flex-end center">
        <button-spinner class="ml-xxs" [inProgress]="isDeleting" diameter="20">
        </button-spinner>
        <button type="button" class="upper action-button butt-back action-button-icon"
            (click)="goBack()"
        >
            <p class="upper">Wróć</p>
            <mat-icon class="action-icon">keyboard_return</mat-icon>
        </button>
        <button (click)="openDialog()"
            [disabled]="isDeleting" class="upper action-button butt-red action-button-icon"
        >
            <p class="upper">usuń</p>
            <mat-icon class="action-icon">delete</mat-icon>
        </button>
        <button (click)="navToEdit()"
            class="upper action-button butt-primary action-button-icon">
            <p class="upper">edytuj</p>
            <mat-icon class="action-icon">edit</mat-icon>
        </button>
    </div>
</div>
